import { canv } from '@/canv/global.js'
import {setClick, getTarget, sleep} from '@/canv/utils.js';

export class timerWindow {
    async open() {
        this.close();

        this.audio = new Audio(`https://${canv.getInitDataProp('appDomain')}/api/v2/static/media/EndTime2.mp3`);

        canv.appInterface.usersWindow.close();

        var timerWindowWrapper = document.createElement('div');
        document.body.append(timerWindowWrapper);

        timerWindowWrapper.outerHTML = this.getWindow();

        await sleep(100);
        const timer = document.getElementsByClassName("timerWindow")[0];
        timer.classList.add("timerWindowReady");

        this.setStatus(this.status);
        this.updateTimerVisuals();
        this.init();
    }

    setStatus(status) {
        this.tryOpenTimer();
        this.status = status;

        if (this.status == "running") {
            // меняем svg на паузу
            const timerWindowControllsTopItemRun = document.getElementsByClassName("timerWindowControllsTopItemRun")[0];
            timerWindowControllsTopItemRun.innerHTML = this.getPause();

            // показывам кнопку стоп
            const timerWindowControllsTopItemStop = document.getElementsByClassName("timerWindowControllsTopItemStop")[0];
            timerWindowControllsTopItemStop.classList.add("timerWindowControllsTopItemStopShow");

            const markInputs = document.getElementsByClassName("timerWindowTimeInput");
            for (var i = 0; i < markInputs.length; i++) {
                markInputs[i].setAttribute("readonly", true);
            }
        } else if (this.status == "stopped") {
            // меняем svg на play
            const timerWindowControllsTopItemRun = document.getElementsByClassName("timerWindowControllsTopItemRun")[0];
            timerWindowControllsTopItemRun.innerHTML = this.getPlay();

            // прячем кнопку стоп
            const timerWindowControllsTopItemStop = document.getElementsByClassName("timerWindowControllsTopItemStop")[0];
            timerWindowControllsTopItemStop.classList.remove("timerWindowControllsTopItemStopShow");

            const markInputs = document.getElementsByClassName("timerWindowTimeInput");
            for (var i = 0; i < markInputs.length; i++) {
                markInputs[i].removeAttribute("readonly");
            }
        } else {
            // меняем svg на play
            const timerWindowControllsTopItemRun = document.getElementsByClassName("timerWindowControllsTopItemRun")[0];
            timerWindowControllsTopItemRun.innerHTML = this.getPlay();

            // прячем кнопку стоп
            const timerWindowControllsTopItemStop = document.getElementsByClassName("timerWindowControllsTopItemStop")[0];
            timerWindowControllsTopItemStop.classList.add("timerWindowControllsTopItemStopShow");

            const markInputs = document.getElementsByClassName("timerWindowTimeInput");
            for (var i = 0; i < markInputs.length; i++) {
                markInputs[i].setAttribute("readonly", true);
            }
        }
    }


    close() {
        const timerWindow = document.getElementsByClassName("timerWindow")[0];

        if (timerWindow != undefined) {
            timerWindow.outerHTML = "";
        }
    }

    init() {

        setClick("timerWindowClose", this.close.bind(this));
        setClick("timerWindowControllsTopItemRun", this.actionTimer.bind(this));
        setClick("timerWindowControllsTopItemStop", this.stopTimerButton.bind(this));
        setClick("timerWindowControllsPlus", this.plusMin.bind(this));


        const timerInputs = document.getElementsByClassName("timerWindowTimeInput");
        const inputFocusProccessor = (e) => {
            canv.appInterface.inputFocused = 1;
        };
        for (var i = 0; i < timerInputs.length; i++) {
            timerInputs[i].addEventListener('focus', inputFocusProccessor, false);
            timerInputs[i].addEventListener('blur', this.inputBlur.bind(this), false);
            timerInputs[i].addEventListener('keypress',  this.inputKey.bind(this), false);

        }

    }


    // Proccessors

    inputKey(e) {
        if (e.key < "0" || e.key > "9") {
            e.preventDefault();
            return;
        }

        const markInput = getTarget(e, "timerWindowTimeInput")
        if (markInput.value.length >= 2) {
            e.preventDefault();
            return;
        }
    }

    inputBlur() {
        canv.appInterface.inputFocused = 0;

        const markInputMin = document.getElementsByClassName("timerWindowTimeInputMin")[0];
        const markInputSec = document.getElementsByClassName("timerWindowTimeInputSec")[0];
        const minValue = markInputMin.value !== "" ? Number.parseInt(markInputMin.value) : 0;
        const secValue = markInputSec.value !== "" ? Number.parseInt(markInputSec.value) : 0;

        const totalSecs = minValue * 60 + secValue;

        this.currentTime = totalSecs;
        this.updateTimerVisuals();

    }



    // Actions

    actionTimer() {
        if (this.status == "running") {
            this.pauseTimer();
            canv.intercom.fastMessage("timer", {
                "action": "pause",
                "time": this.currentTime
            });
        } else if (this.status == "stopped" || this.status == "paused") {
            this.runTimer();
            canv.intercom.fastMessage("timer", {
                "action": "run",
                "time": this.currentTime
            });
        }

    }

    runTimer() {
        this.inputBlur(); // если будучи input focused нажать play, то сначала спабатывает runTimer и отправляется event. Поэтому тут уже нужно обновить this.currentTime

        if (this.status == "stopped") {
            this.lastSetted = this.currentTime;
        }


        this.setStatus("running");
        this.timer = setTimeout(this.timerEvery.bind(this), 1000);

        const barPanelLeftTimerTime = document.getElementsByClassName("barPanelLeftTimerTime")[0];

        if (barPanelLeftTimerTime !== undefined) {
            barPanelLeftTimerTime.classList.add('running');
        }

    }

    pauseTimer() {
        clearTimeout(this.timer);
        this.setStatus("paused");
    }

    timerEvery() {
        this.currentTime = this.currentTime - 1;
        this.updateTimerVisuals();

        if (this.currentTime == 0) {
            this.stopTimer();
            this.audio.play();
        } else {
            this.timer = setTimeout(this.timerEvery.bind(this), 1000);
        }
    }

    stopTimerButton() {
        this.stopTimer();
        canv.intercom.fastMessage("timer", {
            "action": "stop",
            "time": this.currentTime
        });
    }

    stopTimer() {
        this.setStatus("stopped");
        clearTimeout(this.timer);
        this.currentTime = this.lastSetted;
        this.updateTimerVisuals();

        const barPanelLeftTimerTime = document.getElementsByClassName("barPanelLeftTimerTime")[0];

        if (barPanelLeftTimerTime !== undefined) {
            barPanelLeftTimerTime.classList.remove('running');
        }
    }

    plusMin() {
        this.currentTime = this.currentTime + 60;
        this.updateTimerVisuals();
        canv.intercom.fastMessage("timer", {
            "action": "time_udpate",
            "time": this.currentTime
        });
    }


    // message

    proccessTimerMessage(data) {
        if (data["action"] == "run") {
            this.tryOpenTimer();
            clearTimeout(this.timer);

            this.currentTime = data["time"];
            this.updateTimerVisuals();

            this.runTimer();
        } else if (data["action"] == "pause") {
            this.pauseTimer();
        } else if (data["action"] == "stop") {
            this.stopTimer();
        } else if (data["action"] == "time_udpate") {
            this.currentTime = data["time"];
            this.updateTimerVisuals();
        }
    }

    tryOpenTimer() {
        const timerWindow = document.getElementsByClassName("timerWindow")[0];
        if (timerWindow == undefined) {
            this.open();
        }
    }





    // Helpers

    // обновляет все отображаемые таймеры в соответствие с this.currentTime
    updateTimerVisuals() {
        const min = Math.floor(this.currentTime / 60);
        const sec = this.currentTime - min * 60;

        const minVis = this.timeToVisual(min);
        const secVis = this.timeToVisual(sec);

        const timerWindow = document.getElementsByClassName("timerWindow")[0];

        if (timerWindow != undefined) {
            const minInput = document.getElementsByClassName("timerWindowTimeInputMin")[0];
            const secInput = document.getElementsByClassName("timerWindowTimeInputSec")[0];

            minInput.value = minVis;
            secInput.value = secVis;
        }

        const barPanelLeftTimerTime = document.getElementsByClassName("barPanelLeftTimerTime")[0];

        if (barPanelLeftTimerTime !== undefined) {
            barPanelLeftTimerTime.innerHTML = minVis + ":" + secVis;
        }
    }

    timeToVisual(time) {
        if (time == 0) {
            return "00";
        } else if (time <= 9) {
            return "0" + time.toString();
        }

        return time.toString();
    }

    // Tempalates

    getWindow() {
        return `
            <div class="timerWindow">
                <div class="timerWindowTime">
                    <input type="text" class="timerWindowTimeInput timerWindowTimeInputMin">
                    <div class="timerWindowTimeDots">:</div>
                    <input type="text" class="timerWindowTimeInput timerWindowTimeInputSec">
                </div>
                <div class="timerWindowControlls">
                    <div class="timerWindowControllsTop">
                        <div class="timerWindowControllsTopItem timerWindowControllsTopItemRun">
                            <svg class="svg" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"><path fill="white" fill-opacity="1" fill-rule="evenodd" stroke="none" d="m4 .098.765.478 8 5 .678.424-.678.424-8 5-.765.478V.098zm1 1.804v8.196L11.557 6 5 1.902z"></path></svg>
                        </div>
                        <div class="timerWindowControllsTopItem timerWindowControllsTopItemStop">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Media / Stop">
                                <path id="Vector" d="M5 8.2002V15.8002C5 16.9203 5 17.4796 5.21799 17.9074C5.40973 18.2837 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8036C16.9215 19 17.4805 19 17.9079 18.7822C18.2842 18.5905 18.5905 18.2837 18.7822 17.9074C19 17.48 19 16.921 19 15.8031V8.19691C19 7.07899 19 6.5192 18.7822 6.0918C18.5905 5.71547 18.2842 5.40973 17.9079 5.21799C17.4801 5 16.9203 5 15.8002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="timerWindowControllsPlus">
                        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2a1 1 0 0 0-1 1v4H3a1 1 0 0 0 0 2h4v4a1 1 0 1 0 2 0V9h4a1 1 0 1 0 0-2H9V3a1 1 0 0 0-1-1Z" fill="black"></path></svg>
                        <p>1 мин</p>
                    </div>
                </div>
                <div class="timerWindowClose">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Menu / Close_MD">
                    <path id="Vector" d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18" stroke="grey" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                    </svg>
                </div>
            </div>
        `;
    }

    getPlay() {
        return `<svg class="svg" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"><path fill="white" fill-opacity="1" fill-rule="evenodd" stroke="none" d="m4 .098.765.478 8 5 .678.424-.678.424-8 5-.765.478V.098zm1 1.804v8.196L11.557 6 5 1.902z"></path></svg>
        `;
    }

    getPause() {
        return `
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Media / Pause">
            <g id="Vector">
            <path d="M15 5.5V18.5C15 18.9647 15 19.197 15.0384 19.3902C15.1962 20.1836 15.816 20.8041 16.6094 20.9619C16.8026 21.0003 17.0349 21.0003 17.4996 21.0003C17.9642 21.0003 18.1974 21.0003 18.3906 20.9619C19.184 20.8041 19.8041 20.1836 19.9619 19.3902C20 19.1987 20 18.9687 20 18.5122V5.48777C20 5.03125 20 4.80087 19.9619 4.60938C19.8041 3.81599 19.1836 3.19624 18.3902 3.03843C18.197 3 17.9647 3 17.5 3C17.0353 3 16.8026 3 16.6094 3.03843C15.816 3.19624 15.1962 3.81599 15.0384 4.60938C15 4.80257 15 5.03534 15 5.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 5.5V18.5C4 18.9647 4 19.197 4.03843 19.3902C4.19624 20.1836 4.81599 20.8041 5.60938 20.9619C5.80257 21.0003 6.0349 21.0003 6.49956 21.0003C6.96421 21.0003 7.19743 21.0003 7.39062 20.9619C8.18401 20.8041 8.8041 20.1836 8.96191 19.3902C9 19.1987 9 18.9687 9 18.5122V5.48777C9 5.03125 9 4.80087 8.96191 4.60938C8.8041 3.81599 8.18356 3.19624 7.39018 3.03843C7.19698 3 6.96465 3 6.5 3C6.03535 3 5.80257 3 5.60938 3.03843C4.81599 3.19624 4.19624 3.81599 4.03843 4.60938C4 4.80257 4 5.03534 4 5.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            </g>
        </svg>
        `;
    }


    currentTime = 30; // sec
    lastSetted = 30;
    timer = null;
    status = "stopped";
    audio = null;
}
